module.exports = __webpack_public_path__ + "static/media/01.2c4fdf93.jpg";